<div *ngIf="field" class="form-element custom-select">
  <div *ngIf="field.tooltip" class="relative">
    <div class="absolute top-0 right-0">
      <app-tooltip data-cy="tooltip">
        <div class="tooltip-content">
          <span [innerHTML]="field.tooltip | translate"> </span>
        </div>
      </app-tooltip>
    </div>
  </div>

  <label class="form-label" *ngIf="field && field.label" for="{{ field.id }}">
    {{ field.label | translate }}
  </label>

  <div [placement]="placement" ngbDropdown>
    <button id="ngb-{{ field.id }}" class="select-dropdown" ngbDropdownToggle [disabled]="disabled">
      <span *ngIf="control?.value && control?.value !== 'other'">
        {{ field.options[control?.value] | translate }}
      </span>
      <span *ngIf="control?.value && control?.value === 'other' && field.addOther">
        {{ "general.other" | translate }}
      </span>

      <div *ngIf="!control?.value" class="opacity-70">
        <span *ngIf="field.placeholder">{{ field.placeholder | translate }}</span>
        <span *ngIf="!field.placeholder">{{ "general.select.placeholder" | translate }}</span>
      </div>
      <input
        id="{{ field.id }}"
        class="hidden"
        readonly
        name="boiler"
        type="text"
        autocomplete="off"
        [attr.formControlName]="field.id"
      />
    </button>
    <div
      class="select-content"
      ngbDropdownMenu
      [attr.aria-labelledby]="'ngb-' + field.id"
      [ngClass]="{ 'select-content__top': placement === 'top' }"
      data-cy="dropdown-menu"
    >
      <ng-container *ngFor="let option of field.options | keyvalue: getSort(field.sort)">
        <button
          *ngIf="!control?.value || (control?.value && control?.value !== option.value)"
          ngbDropdownItem
          (click)="updateSelection(control, option.key)"
        >
          {{ option.value | translate }}
        </button>
      </ng-container>
      <button
        *ngIf="field.addOther && (!control?.value || (control?.value && control?.value !== 'other'))"
        ngbDropdownItem
        (click)="updateSelection(control, 'other')"
      >
        {{ "general.other" | translate }}
      </button>
    </div>
  </div>
</div>
